import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bcff41ac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container text-center" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "h1 mt-4 pt-4 col-6 justify-content-center" }, " Check Calls ", -1))
const _hoisted_4 = {
  key: 1,
  class: "modal-overlay"
}
const _hoisted_5 = { class: "modal-content" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Face Verification Required", -1))
const _hoisted_7 = {
  ref: "verificationVideoRef",
  autoplay: "",
  muted: "",
  width: "400",
  height: "300",
  style: {"border":"2px solid #ccc","background-color":"#000"}
}
const _hoisted_8 = {
  ref: "verificationCanvasRef",
  style: {"display":"none"}
}
const _hoisted_9 = { class: "mt-3" }
const _hoisted_10 = { key: 2 }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "col-4 col-sm-1 text-top m-0 p-0",
  src: "StartDuty.png"
}, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-6 col-sm-2 text-light h3 mt-2 pt-4" }, " Start Duty Call ", -1))
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = { key: 3 }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "col-4 col-sm-1 text-top m-0 p-0",
  src: "StartDuty.png"
}, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-6 col-sm-2 text-light h3 mt-2 pt-4" }, " Duty Check Call ", -1))
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = { key: 4 }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "col-4 col-sm-1 text-top m-0 p-0",
  src: "StartDuty.png"
}, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-6 col-sm-2 text-light h3 mt-2 pt-4" }, " End Duty Call ", -1))
const _hoisted_21 = [
  _hoisted_19,
  _hoisted_20
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.GetCurrentJobsForOfficer && $setup.GetCurrentJobsForOfficer(...args))),
          class: "btn btn-danger col-5 col-sm-2 m-4 p-4"
        }, " Refresh Check Calls ")
      ]),
      ($setup.showResultBanner)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass([$setup.resultBannerClass, "result-banner"])
          }, [
            _createTextVNode(_toDisplayString($setup.resultMessage) + " ", 1),
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.showResultBanner = false)),
              class: "close-btn"
            }, "×")
          ], 2))
        : _createCommentVNode("", true),
      ($setup.showFaceVerification)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("video", _hoisted_7, null, 512),
              _createElementVNode("canvas", _hoisted_8, null, 512),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("p", null, _toDisplayString($setup.verificationStatus), 1),
                _createElementVNode("button", {
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.confirmFaceVerification && $setup.confirmFaceVerification(...args))),
                  class: "btn btn-primary m-2"
                }, " Verify Face "),
                _createElementVNode("button", {
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.cancelFaceVerification && $setup.cancelFaceVerification(...args))),
                  class: "btn btn-secondary m-2"
                }, " Cancel ")
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      ($setup.StartingJob != null)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("a", {
              onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.checkFaceAndStartDuty($setup.StartingJob.jobId, 2, 1, 'job-started', 'start test'))),
              class: "container row"
            }, _hoisted_13)
          ]))
        : _createCommentVNode("", true),
      ($setup.RunningJob != null)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _createElementVNode("a", {
              onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.checkFaceAndStartDuty($setup.RunningJob.jobId, 0, 2, 'check-call', 'check-call test'))),
              class: "container row"
            }, _hoisted_17)
          ]))
        : _createCommentVNode("", true),
      ($setup.EndingJob != null)
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
            _createElementVNode("a", {
              onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.checkFaceAndStartDuty($setup.EndingJob.jobId, 9, 3, 'job-ended', 'end test'))),
              class: "container row"
            }, _hoisted_21)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}